export default "__VITE_ASSET__54438133__"